import {
  CasDisplayField,
  CasRHFAutocompleteAsync,
  CasStackRow,
} from 'src/compass/shared/components';
import { Terms } from 'src/compass/shared/util/terms';
import { IGeneralObjectType } from 'src/compass/site/util';

export default function AccountForm({ row }: { row: IGeneralObjectType}) {
  return (
    <>
      <CasStackRow>
        <CasDisplayField label="Acct Name" value={row?.company} />
        <CasDisplayField label="Account#" value={row?.accountNumber} />
      </CasStackRow>
      <CasDisplayField label={`Current ${Terms.Customer.label}`} value={row?.entityName} />
      <CasRHFAutocompleteAsync
        url="Utilities/Entity/List"
        name="entityObj"
        label={`Change to ${Terms.Customer.label}`}
      />
    </>
  );
}
